var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b19e99d075cbb1a9c6c8559acdbd1eb4448bf24d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["everest@noissue"]={id:"b19e99d075cbb1a9c6c8559acdbd1eb4448bf24d"};
      